import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TraineeListService } from '../../service/trainee-list.service';
import { AvatarService } from '../../service/avatar.service';
import { TextToSpeechService } from '../../service/text-to-speech/text-to-speech.service';
import { InteractionService } from '../../service/interaction/interaction.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router'
import { ScheduleOutageService } from '../../service/admin/schedule-outage/schedule-outage.service';
// import { ScheduleOutageComponent } from '../admin/system-config/schedule-outage/schedule-outage.component';
@Component({
    selector: 'app-customize-dialog',
    templateUrl: './customize-dialog.component.html',
    styleUrl: './customize-dialog.component.scss',
    standalone: false
})
export class CustomizeDialogComponent implements OnInit, OnDestroy {
  additionalInfo: string;
  test: boolean;
  test2: boolean;
  test3: boolean;
  test4: boolean;
  test5: boolean;
  test6: boolean;
  test7: boolean;
  CustomizeForm: FormGroup;
  historyDays: number;
  idleMinutes: number;
  historicalQA: number;
  textArea: string;
  ai_guideline_url: string;
  ai_guideline_message: string;
  top_k: number;
  retrieved_chunk_num: number;
  datasource: any;
  showVoiceOptions = false;
  selectedVoiceType: string = '';  // To store the selected voice type
  selectedVoice: string = '';
  selectedVoiceValue: string;
  avatarVoiceList: any[];
  fileUploadControl;
  user_guide: string;
  app_user_guide: string;
  // @ViewChild('scheduleOutage') scheduleOutage!: ScheduleOutageComponent;

  voiceOptions = [];
  voiceList: any[];
  textToSpeechControl;
  videoInteractionEnabled;
  supplementaryQuestionEnabled: boolean;
  show_showpad_url: boolean;
  disable: boolean = false;
  // idle -> loading (waiting for synthesis) -> playing (audio streaming)
  voicePreviewState: 'idle' | 'loading' | 'playing' = 'idle';
  private voicePreviewSubscriptions: Subscription = new Subscription();
  constructor(
    private fb: FormBuilder, public router: Router,
    public TraineeService: TraineeListService, public AvatarService: AvatarService,
    private tts: TextToSpeechService, private readonly intService: InteractionService, public toaster: ToastrService,
    private scheduleOutageService: ScheduleOutageService
  ) {
  }
  ngOnInit(): void {
    // Real audio start (after synthesis latency): switch loader -> playing.
    this.voicePreviewSubscriptions.add(
      this.tts.audioStarted$.subscribe(() => {
        if (this.voicePreviewState === 'loading') {
          this.voicePreviewState = 'playing';
        }
      })
    );
    // Audio finished / stopped -> reset back to play icon.
    this.voicePreviewSubscriptions.add(
      this.tts.playbackState$.subscribe(state => {
        if (state === 'idle') {
          this.voicePreviewState = 'idle';
        }
      })
    );
    this.CustomizeForm = this.fb.group({
      historyDays: new FormControl(''),
      idleMinutes: new FormControl(''),
      historicalQA: new FormControl(''),
      top_k: new FormControl(''),
      retrieved_chunk_num: new FormControl(''),
      textArea: new FormControl(''),
      url: new FormControl(''),
      message: new FormControl(''),
      data_source_url: new FormControl(''),
      dashboard_url: new FormControl(''),
      job_scheduler_url: new FormControl(''),
      header_message: new FormControl(''),
      header_url: new FormControl(''),
      user_guide: new FormControl(''),
      app_user_guide: new FormControl('')
    });

    this.TraineeService.getCustomizeDetails().subscribe(res => {
      this.datasource = res;
      this.historyDays = this.datasource.history_days_count;
      this.idleMinutes = this.datasource.idle_minutes;
      this.historicalQA = this.datasource.historical_context_count;
      this.textArea = this.datasource.override_trainee_preferences;
      this.top_k = this.datasource.top_k;
      this.retrieved_chunk_num = this.datasource.retrieved_chunk_num;
      this.ai_guideline_message = this.datasource.ai_guideline_message;
      this.ai_guideline_url = this.datasource.ai_guideline_url;
      this.selectedVoice = this.datasource.avatar_voice;
      this.CustomizeForm.controls['historyDays'].setValue(this.historyDays);
      this.CustomizeForm.controls['idleMinutes'].setValue(this.idleMinutes);
      this.CustomizeForm.controls['historicalQA'].setValue(this.historicalQA);
      this.CustomizeForm.controls['textArea'].setValue(this.textArea);
      this.CustomizeForm.controls['top_k'].setValue(this.top_k);
      this.CustomizeForm.controls['retrieved_chunk_num'].setValue(this.retrieved_chunk_num);
      this.CustomizeForm.controls['message'].setValue(this.ai_guideline_message);  // Set message value
      this.CustomizeForm.controls['url'].setValue(this.ai_guideline_url);
      this.CustomizeForm.controls['data_source_url'].setValue(this.datasource.datasource_url);
      this.CustomizeForm.controls['dashboard_url'].setValue(this.datasource.dashboard_url);
      this.CustomizeForm.controls['job_scheduler_url'].setValue(this.datasource.job_scheduler_url);
      this.CustomizeForm.controls['header_message'].setValue(this.datasource.header_message);
      this.CustomizeForm.controls['header_url'].setValue(this.datasource.header_url);
      this.CustomizeForm.controls['user_guide'].setValue(this.datasource.user_guide);
      this.CustomizeForm.controls['app_user_guide'].setValue(this.datasource.app_user_guide);
      if (!this.datasource.public_domain_response) {
        this.test = true;
      } else {
        this.test = false;
      }

      if (!this.datasource.qualitative_assessment) {
        this.test2 = true;
      } else {
        this.test2 = false;
      }

      if (!this.datasource.rewrite_query) {
        this.test3 = true;
      } else {
        this.test3 = false;
      }

      if (!this.datasource.enable_video_interaction) {
        this.test4 = true;
      } else {
        this.test4 = false;
      }

      if (!this.datasource.hybrid_search) {
        this.test5 = true;
      } else {
        this.test5 = false;
      }

      if (!this.datasource.agent_response) {
        this.test6 = true;
      } else {
        this.test6 = false;
      }

      if (!this.datasource.enable_voice_interaction) {
        this.test7 = true;
        this.toggleVoiceOptions(false);
      } else {
        this.test7 = false;
        this.toggleVoiceOptions(true);

      }
      this.textToSpeechControl = this.datasource.enable_voice_interaction;
      this.videoInteractionEnabled = this.datasource.enable_video_interaction;
      this.fileUploadControl = this.datasource.chat_doc_upload;
      this.supplementaryQuestionEnabled = this.datasource.llm_subsequent_ques;
      this.show_showpad_url = this.datasource.show_showpad_url;
      
      this.AvatarService.getAvatarVoiceList().subscribe(res => {
        this.avatarVoiceList = res;
        this.chooseAvatarVoice(this.datasource.gender_voice)

      });
      this.selectedVoiceType = this.datasource.gender_voice;

    });


  }

  chooseAvatarVoice(voice) {
    this.voiceList = this.avatarVoiceList.filter(item => item.voice_gender === voice);
    this.voiceOptions = this.voiceList.map(item => ({
      label: item.display_name,
      value: item.voice_title,
      voiceId: item.id
    })
    )

  }

  onSelectionChange() {
    // this.chooseAvatarVoice(this.selectedVoiceType)
    this.getVoiceSample();
  }

  getVoiceSample() {
    this.AvatarService.getAvatarVoiceListByGender(this.selectedVoiceType).subscribe(res => {
      this.avatarVoiceList = res;
      this.selectedVoice = this.avatarVoiceList[0].id;  // Set the default voice as first item in the list
      this.chooseAvatarVoice(this.selectedVoiceType);
    });
  }

  toggleVoiceOptions(val) {
    // this.test7 = !val;
    // this.showVoiceOptions = val;  // Toggle the visibility
    this.showVoiceOptions = this.textToSpeechControl;
  }

  textARea() {
    this.textArea = this.CustomizeForm.controls['textArea'].value;
  }
  firstcheck(val) {
    this.test = !val;
  }
  secondcheck(val) {
    this.test2 = !val;
  }
  thirdcheck(val) {
    this.test3 = !val;
  }
  fourthcheck(val) {
    this.test4 = !val;
  }
  fivecheck(val) {
    this.test5 = !val;
  }
  sixcheck(val) {
    this.test6 = !val;
  }
  numericOnly(event): boolean {
    if (event.target.value.length < 4) {
      let patt = /^([0-9])$/;
      let result = patt.test(event.key);
      return result;
    }
    else return false;
  }
  onCancel(): void {
    //this.dialogRef.close();
  }

  onSubmit(): void {
    // if (this.scheduleOutage.outageForm.invalid && !this.scheduleOutage.outageForm.pristine) {
    //   this.toaster.error('Schedule outage form is invalid.');
    //   this.scheduleOutage.outageForm.markAllAsTouched();
    //   return;
    // }

    // this.scheduleOutage.save();

    let submitdata = {
      "public_domain_response": !this.test, //this.publicdomainResponse,
      "qualitative_assessment": !this.test2, //this.qualitativeAssessment,
      "rewrite_query": !this.test3, //this.voiceInteraction,
      // "enable_video_interaction": !this.test4, //this.videoInteraction,
      "enable_video_interaction": this.videoInteractionEnabled, //this.videoInteraction,
      // "enable_voice_interaction": !this.test7, //this.videoInteraction,
      "enable_voice_interaction": this.textToSpeechControl, //this.videoInteraction,
      "history_days_count": parseInt(this.CustomizeForm.controls['historyDays'].value),
      "idle_minutes": parseInt(this.CustomizeForm.controls['idleMinutes'].value),
      "historical_context_count": parseInt(this.CustomizeForm.controls['historicalQA'].value),
      "override_trainee_preferences": this.CustomizeForm.controls['textArea'].value,
      "top_k": parseInt(this.CustomizeForm.controls['top_k'].value),
      "retrieved_chunk_num": parseInt(this.CustomizeForm.controls['retrieved_chunk_num'].value),
      "hybrid_search": !this.test5, //this.hybridSearch,
      "agent_response": !this.test6, //this.agentResponse,
      "gender_voice": this.selectedVoiceType, //this.selectedVoiceType,
      "avatar_voice": this.selectedVoice, //this.avatar_voice,
      "ai_guideline_message": this.CustomizeForm.value.message,
      "ai_guideline_url": this.CustomizeForm.value.url,
      "datasource_url": this.CustomizeForm.value.data_source_url,
      "dashboard_url": this.CustomizeForm.value.dashboard_url,
      "job_scheduler_url": this.CustomizeForm.value.job_scheduler_url,
      "header_message": this.CustomizeForm.value.header_message,
      "header_url": this.CustomizeForm.value.header_url,
      "chat_doc_upload": this.fileUploadControl,
      "llm_subsequent_ques": this.supplementaryQuestionEnabled,
      "user_guide": this.CustomizeForm.value.user_guide,
      "app_user_guide": this.CustomizeForm.value.app_user_guide,
      "show_showpad_url": this.show_showpad_url
    }
    let id = this.datasource.id;
    this.TraineeService.createCustomizeDetails(submitdata, id).subscribe((data: any) => {
      this.intService.updateCustomizationDetails(submitdata);
      this.toaster.success('Saved successfully');
    });


  }
  getSystemConfiguration() {
    this.TraineeService.getCustomizeDetails().subscribe(config => {
    })
  }

  playSampleVoice() {
    // Toggle: if a sample is loading or playing, stop it instead of replaying.
    if (this.voicePreviewState !== 'idle') {
      this.tts.stopSpeech();
      this.voicePreviewState = 'idle';
      return;
    }
    const selectedVoice = this.voiceOptions.find(voice => voice.voiceId == this.selectedVoice);
    if (selectedVoice) {
      this.selectedVoiceValue = selectedVoice.value;
    }
    this.voicePreviewState = 'loading';
    this.tts.previewVoice('Hi, How are you ?', this.selectedVoiceValue);
  }
  questions() {
    this.router.navigate(['/app-question-list'], { skipLocationChange: true });
  }

  ngOnDestroy(): void {
    this.voicePreviewSubscriptions.unsubscribe();
    // Stop any in-flight sample so it doesn't keep playing after the dialog closes.
    if (this.voicePreviewState !== 'idle') {
      this.tts.stopSpeech();
    }
  }

}